import { useEffect, useState, useCallback } from 'react';
import { AxiosError } from 'axios';
import toast from 'react-hot-toast';

import useHttps from '../useHttps';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../models/https';

const useUnsubscribe = (token?: string) => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [failed, setFailed] = useState(false);

  const onUnsubscribeError = (err: AxiosError<ErrorHttpResponse>) => {
    setFailed(true);
    toast.error(err?.response?.data?.message ?? 'Invalid or expired token');
  };

  const onUnsubscribeSuccess = ({ message }: SuccessHttpResponse<any>) => {
    setFailed(false);
    toast.success(message ?? 'Unsubscribed successfully');
  };

  const unsubscribe = useCallback(() => {
    if (!token) return;

    const config: HttpConfig = {
      url: 'settings/unsubscribe',
      method: 'post',
      data: { token },
      headers: {
        'Content-Type': 'application/json',
      },
    };

    request(config, onUnsubscribeSuccess, setLoading, onUnsubscribeError);
  }, [token, request]);

  useEffect(() => {
    unsubscribe();
  }, [unsubscribe]);

  return { loading, failed, tryAgain: unsubscribe };
};

export default useUnsubscribe;
